import { Component, Input, OnChanges} from '@angular/core';
import { Review } from '@product-reviews/data-access';

@Component({
    selector: 'product-reviews-review-features',
    templateUrl: './review-features.component.html',
    styleUrls: ['./review-features.component.scss'],
    standalone: false
})
export class ReviewFeaturesComponent implements  OnChanges {
  @Input() review: Review;
  @Input() filterByUsedFor = false;
  @Input() smallFontFamily = false;
  features: string[] = [];


  ngOnChanges() {
    this.parseReviewContextDataValues();
  }

  private parseReviewContextDataValues():void {
    this.features = [];
    this.review.ContextDataValuesOrder
    ?.filter((key) => this.filterByUsedFor ? key === 'UsedFor' : key !== 'UsedFor')
    ?.map((key) => {
      const item = this.review.ContextDataValues[key];
      const dimensionLabel = !this.filterByUsedFor ? `${item?.DimensionLabel}: ` : '';
      if (dimensionLabel && item.ValueLabel) {
        this.features.push(`${dimensionLabel}${item.ValueLabel}`);
      }
    });
  }
}
